module.exports = __webpack_public_path__ + "img/pin.0f817913.svg";